import { Button, ButtonGroup, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ThemeProvider, Tooltip, useTheme } from "@mui/material";
import { NotificationDialogType } from "../utils/Types";
import { deepmerge } from "@mui/utils";
import { ButtonFormTheme, GridColorStyles } from "../expanded-theme";
import {
    Check as CheckIcon,
    Close as CloseIcon,
} from '@mui/icons-material';
import { buttonTheme } from "../utils/Common";

function NotificationDialog(props: NotificationDialogType) {
    const {
        onClose,
        message,
        title,
        onConfirm,
        confirmButtonText,
        closeButtonText,
        warning,
        confirm,
    } = props;
    const theme = useTheme();
    const commonTheme = {
        padding: "1rem !important",
    };

    return (
        <Dialog
            fullScreen={false}
            open={true}
            onClose={onClose}
            aria-labelledby="responsive-dialog-title"
            sx={{
                borderRadius: "1rem",
            }}
        >
            <DialogTitle
                id="responsive-dialog-title"
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    ...commonTheme,
                }}
                className={
                    warning ? "text-bg-danger"
                    :
                    confirm ? "text-bg-info"
                    :
                    ""
                }
            >
            {
                title
            }
                <ThemeProvider theme={buttonTheme}>
                    <ButtonGroup>
                        <Tooltip
                            title={closeButtonText}
                            arrow
                        >
                            <Button
                                variant={warning || confirm ? "outlined" : "contained"}
                                autoFocus
                                onClick={onClose}
                                color="white"
                                className={warning || confirm ? "border-none" : ""}
                            >
                                <CloseIcon fontSize="small"/>
                            </Button>
                        </Tooltip>
                    </ButtonGroup>
                </ThemeProvider>
            </DialogTitle>
            <DialogContent sx={{...commonTheme}}>
                <DialogContentText>
					<p>{message}</p>
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{...commonTheme}}>
                <ThemeProvider theme={buttonTheme}>
                    <ButtonGroup>
                    {
                        onConfirm ?
                        <Tooltip
                            title={confirmButtonText}
                            arrow
                        >
                            <Button
                                variant="contained"
                                autoFocus
                                onClick={onConfirm}
                                color={
                                    warning ? "error"
                                    :
                                    confirm ? "info"
                                    :
                                    "white"
                                }
                                className={warning || confirm ? "border-none" : ""}
                            >
                                <CheckIcon fontSize="small"/>
                            </Button>
                        </Tooltip>
                        :
                        null
                    }
                    </ButtonGroup>
                </ThemeProvider>
            </DialogActions>
        </Dialog>
    );
}

export default NotificationDialog;
